import { render, staticRenderFns } from "./MoneyBackIcon.vue?vue&type=template&id=33512b1d&scoped=true"
import script from "./MoneyBackIcon.vue?vue&type=script&lang=js"
export * from "./MoneyBackIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33512b1d",
  null
  
)

export default component.exports